<mat-card class="expandend-card " [id]="tourId.workflows.wfrun.wfQualityGates.id">
    <!-- quality gate in feature workflow -->
    <h2>Quality gate summary</h2>

    <app-table-normal [columnsToDisplay]=columnsToDisplay [columnHeaders]=columnHeaders [dataSource]=dataSource
        id="wf-qualityGates"></app-table-normal>
</mat-card>